/**
 * Removes members-only line items from the cart when the shopper has no access.
 * Config is provided by snippets/members-gate-config.liquid (#members-gate-config).
 */

import { readMembersGateConfig } from '@theme/members-gate';

async function fetchCart() {
  const response = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Failed to load cart');
  return response.json();
}

async function removeLineItems(lineKeys) {
  if (!lineKeys.length) return null;

  const updates = {};
  for (const key of lineKeys) {
    updates[key] = 0;
  }

  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates }),
  });

  if (!response.ok) throw new Error('Failed to update cart');
  return response.json();
}

function gatedKeysFromCart(cart, gatedProductIds) {
  const gated = new Set(gatedProductIds.map(String));
  const keys = [];

  for (const item of cart.items || []) {
    if (gated.has(String(item.product_id))) {
      keys.push(item.key);
    }
  }

  return keys;
}

async function enforceMembersCart(config) {
  if (!config?.enabled || config.hasAccess) return;

  const gatedProductIds = config.gatedProductIds || [];
  if (!gatedProductIds.length) return;

  const cart = await fetchCart();
  const keys = gatedKeysFromCart(cart, gatedProductIds);
  if (!keys.length) return;

  await removeLineItems(keys);

  document.dispatchEvent(
    new CustomEvent('cart:update', {
      detail: { data: { source: 'members-gate' } },
      bubbles: true,
    })
  );
}

const config = readMembersGateConfig();
if (config.enabled && !config.hasAccess) {
  enforceMembersCart(config).catch(() => {});
}
